export const SceneTemplate = {
  display: 'flex',
  round: 'A',
  padding: 'A',
  theme: (el) => `scene @${el.getRootState('sceneTheme')}`,
  transition: 'B defaultBezier',
  transitionProperty: 'max-width, background',
  backdropFilter: 'blur(5px)',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',

  scene: {
    position: 'absolute',
    inset: '0 0 0 0',
    boxSize: '100%',
    round: 'A',
    flow: 'y',
    align: 'center center'
  },

  ':before': {
    content: '""',
    // Decoration-only layer — take out of flex flow so the real content
    // (IframeContainer) centers inside the preview box. Previously this
    // `:before` ran as a flex item with `width: 100%` and shoved every
    // sibling off-axis, which showed up as the iframe being right-aligned
    // at smaller device presets.
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    boxSizing: 'border-box',
    theme: (el) => `dots @${el.getRootState('sceneTheme')}`,

    backgroundPosition: `top`,
    backgroundRepeat: `repeat`,
    backgroundSize: '20px 20px'
  }
}
